module.exports = __webpack_public_path__ + "img/trends_5.df029395.jpg";